import React from 'react';
export const EndOfTable = ({ hasEnded, children }) => {
    if (!hasEnded || !children) {
        return null;
    }
    return (React.createElement("div", { className: "end-of-table" },
        React.createElement("span", { className: "end-of-table_title" }, children)));
};
//# sourceMappingURL=EndOfTable.js.map